<template>
    <div class="card shadow-sm overflow-hidden">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>已選地盤</strong>
            </div>
        </div>
        <div class="card-body p-2">
            <div class="flex-grow-1">
                <h6 class="font-weight-bolder mb-0">
                    {{ site ? site.siteName : "" }}
                </h6>
                <p class="mb-0">
                    <small>
                        {{ site ? site.address : "" }}
                    </small>
                </p>
            </div>
        </div>
        <div class="map">
            <gmap-map class="gmap h-100 w-100"
                      v-bind:center="coordinate"
                      v-bind:zoom="16"
                      v-bind:map-type-id="defaultMapType"
                      v-bind:options="defaultMapOptions">
                <gmap-marker v-bind:position="coordinate"
                             v-bind:animation="2">
                </gmap-marker>
            </gmap-map>
        </div>
    </div>
</template>

<script>
export default {
    name: "TaskMap",
    components: {

    },
    props: {
        "taskId": {
            type: String,
        },
        "site": {
            type: Object,
        },
    },
    data () {
        return {
            defaultMapType: "roadmap",
            defaultMapOptions: {
                "zoomControl": false,
                "mapTypeControl": false,
                "scaleControl": false,
                "streetViewControl": false,
                "rotateControl": false,
                "fullscreenControl": false,
                "disableDefaultUi": true,
            },
        };
    },
    computed: {
        coordinate () {
            return this.site?.coordinate ?? { "lat": 22.2842, "lng": 114.1527 };
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}

.btn-change {
    line-height: 1.25;
    font-size: 0.8rem;
}

.map {
    height: 175px;
}
</style>
